<section class="mainTopBanner checker-banner section-pd">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">自動文件編輯</h1>
                        <h2>MS Word 文件 <br />快速編修超省時</h2>
                        <p>自動完成文法修正，下載含修訂記錄的文件，迅速定稿無煩惱。</p>
                        <div class="btn-group">
                            <a href="https://cloud.trinka.ai/signup?_rg=TW" class="filled-btn" target="_blank">開始使用</a>
                        </div>
                    </div>
                    <div class="top-banner-right">
                        <div id="proofread-file" class="carousel slide" data-ride="carousel">
                            <div class="row">
                                <div class="col-12">
                                    <div class="carousel-inner">
                                        <div class="carousel-item active">
                                            <img src=".././../../assets/images/features/proofread-file/AutoEditBanner.webp" alt="proofread file english" class="img-fluid" />
                                        </div>
                                        <div class="carousel-item">
                                            <img src=".././../../assets/images/features/proofread-file/AutoEditBanner-spanish.webp" alt="proofread file spanish" class="img-fluid" />                                        
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="cs-dots">
                                        <h6 class="text-start text-left">支援語言</h6>
                                        <div class="carousel-indicators">
                                            <button type="button" data-target="#proofread-file" data-slide-to="0" class="active">英文</button>
                                            <button type="button" data-target="#proofread-file" data-slide-to="1">西班牙文</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="howItWorks section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="list-wrapper-image">
                    <a href="" data-toggle="modal" data-target="#youtubeModalPopup" id="VewiVideoSection">
                        <img src=".././../../assets/images/yt-thumbnail/AutoFileEditThumbnail.webp" loading="lazy" decoding="async" alt="proofread for grammar errors" class="img-fluid eposter-img">
                    </a>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="list-wrapper-content-2">
                    <div class="trinka-title mb-0">
                        <h2>觀看教學</h2>
                        <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                        <p>立即觀看操作教學影片，快速上手「自動文件編輯」功能！</p>
                        <p>透過簡單的教學影片，讓你一步步學會如何使用 Trinka。</p>
                        <p class="mb-0">還有其他問題嗎？歡迎瀏覽我們的常見問答</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>自動文件編輯主要特點</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>免安裝外掛麻煩！使用「自動文件編輯」功能，直接修正文稿。Trinka 自動以修訂模式幫你編輯，下載後即可快速完成定稿。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <img src="../../../assets/images/DownloadTrackChangesEdit.svg" loading="lazy" decoding="async" alt="download icon">
                    <h3>下載含修訂記錄的文件</h3>
                    <p>下載並完成帶有 Trinka 編輯器中各項修改標記的修訂檔案。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <img src="../../../assets/images/RetainOriginalFormatting.png" loading="lazy" decoding="async" alt="retain original formatting">
                    <h3>保留原始格式</h3>
                    <p>您的文件內容會以修訂模式呈現所有修改，確保原始格式完整保留不變。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <img src="../../../assets/images/languageScore_icon.svg" loading="lazy" decoding="async" alt="language score">
                    <h3>語言評分</h3>
                    <p>根據各類別的修訂次數，提供文件整體語言品質的指標分數。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="../../../assets/images/TableofRevisions_icon.svg" loading="lazy" decoding="async" alt="table of revisions">
                    <h3>修訂列表</h3>
                    <p>查看依語言類別分類的詳細修訂表，快速掌握所做的修改類型。</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="../../../assets/images/style_guide_icon.svg" loading="lazy" decoding="async" alt="style guide preferences">
                    <h3>選定風格指南</h3>
                    <p>依照常用學術風格指南（如 AMA 第11版、AGU 2017版）調整文稿的文法與用字，確保符合規範。</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="../../../assets/images/subjectAreaAndDocumentType.svg" loading="lazy" decoding="async" alt="subject area and document type">
                    <h3>專業領域和文件類型</h3>
                    <p>根據您的研究主題與稿件類型，客製化 Trinka 建議提醒，提供最相關的修正與建議。</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd pt-0">
    <app-power-mode-section></app-power-mode-section>
</section>

<app-import-files></app-import-files>

<section class="bg-light">
    <app-security-section></app-security-section>
</section>

<section class="sampleReport section-pd">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>查看樣本報告</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
            <div class="col-sm-10">
                <div class="viewSampleReportImg">
                    <div class="btn-group">
                        <a href="../../../assets/resources/AutoEdit_sample_edited.docx" class="filled-btn" target="_blank">
                            查看完整報告
                            <svg fill="#ffffff" width="16px" height="16px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M14 3.414L9.414 8 14 12.586v-2.583h2V16h-6v-1.996h2.59L8 9.414l-4.59 4.59H6V16H0v-5.997h2v2.583L6.586 8 2 3.414v2.588H0V0h16v6.002h-2V3.414zm-1.415-1.413H10V0H6v2H3.415L8 6.586 12.585 2z" fill-rule="evenodd"></path> </g></svg>
                        </a>
                    </div>
                    <img src="../../../assets/images/features/proofread-file/revised-menuscript.webp" width="790" height="691" alt="grammar checker sample report" />
                </div>
            </div>
        </div>
    </div>
</section>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="trinka-title text-center">
                    <h3 class="text-white">自動編輯您的Word文件</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <a href="https://cloud.trinka.ai/signup?_rg=TW" class="white-btn" target="_blank">開始使用</a>
                </div>
            </div>
        </div>  
    </div>
</section>

<section class="section-pd pb-0">
    <app-credits-info
        [title]="'使用點數完成自動文件編輯'"
        [description]="'文件中每5000個單詞將花費1個點數。您可以使用免費點數並根據需要時再靈活加購。'"
        [subText]="'點數就像代幣一樣，可以讓您靈活使用多項 Trinka 功能。<br/> 高級用戶每月將獲得10個免費點數，基本用戶每月獲得4個免費點數。要瞭解更多資訊，請按一下 <a href=\'/features/credits\' class=\'text-link\'>此處</a>。'"
    ></app-credits-info>
</section>

<section class="faqQuestionAnwser section-pd" #target>
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>常見問答</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        當我上傳文件進行校對時我會得到什麼？</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <h4>使用自動文件編輯上傳文件後，您將獲得：</h4>
                                        <ol>
                                            <li>含有所有修訂標記的編輯檔案，您可以使用 Microsoft Word 或其他相容的文字處理軟體檢視、接受或拒絕修正。檔案中也會附有說明修改原因的註解。</li>
                                            <li>詳盡的編輯報告，包含修訂次數、文法錯誤類型統計，以及整體寫作品質評分。</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">
                                        是否可以一次批量上傳多個文件？有文件上傳數量限制嗎？</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>您可以上傳任意數量的文檔進行自動編輯。對文件數量也沒有限制。文件中每5000個單詞僅花費1個點數。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        我要怎麼自己試用自動文件編輯功能？
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>只要在 <a href="https://cloud.trinka.ai/signup_rg=TW" class="text-link" target="_blank">Trinka 註冊帳號</a>，登入後在平台後台左側選單就會看到「自動文件編輯」選項。</p>
                                        <p>上傳文件後，點擊「開始編輯」，您在幾分鐘內就可以獲取自動編輯後的文檔！</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        使用「自動文件編輯」需要多少點數?
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>基本用戶每月可獲得4個免費點數，高級用戶每月可獲得10個免費點數。使用自動文件編輯功能， 檔中的每5000個單詞將花費1個點數。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-trinka-in-other-apps></app-trinka-in-other-apps>

<div class="modal" id="youtubeModalPopup">
    <div class="modal-dialog modal-dialog-centered modal-lg">
       <div class="modal-content">
          <div class="modal-body no-padding">
             <button type="button" class="btn-close" data-dismiss="modal" (click)="stopAllVideos()"></button>
             <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/6Z_PsveCtRQ"
                title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
          </div>
       </div>
    </div>
</div>